import { AddBox, CheckCircle } from "@mui/icons-material"
import { Alert, Box, Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, List, ListItem, ListItemIcon, ListItemText, Modal, Snackbar, TextField, Typography } from "@mui/material"
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const Plans = () => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [loader, setLoader] = useState(true);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [selectedPlan, setSelectedPlan] = useState({})

    const [plans, setPlans] = useState([{
        plan_id: '',
        title: '',
        price: '',
        duration: '',
        features: '',
        createdAt: ''
    }])

    const [plan, setPlan] = useState({
        title: '',
        price: 0,
        duration: '',
        features: ''
    })
    const getPlansRef = useRef();

    const handleOpenEditModal = (plan) => {
        setIsEditModalOpen(true)
        setSelectedPlan(plan)
    }

    const handleOpenDeleteModal = (plan) => {
        setIsDeleteModalOpen(true)
        setSelectedPlan(plan)
    }

    const handleAddPlan = async () => {
        setOpen(true);

        await axiosInstance.post(`plans/create`, plan, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            setMessage(`Success, successfully added ${plan.title}`)
            setTimeout(() => {
                setOpen(false);
                if (getPlansRef.current) getPlansRef.current()
                setIsAddModalOpen(false);
            }, 2000)
        }).catch((error) => {
            if (error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            setTimeout(() => { setOpen(false) }, 2000);
        })
    }

    const handleEditPlan = async () => {
        setOpen(true);

        await axiosInstance.put(`plans/update/${selectedPlan?.plan_id}`, selectedPlan).then((response) => {
            setMessage(`Success, successfully edited ${selectedPlan?.title}`)
            setTimeout(() => {
                setOpen(false);
                if (getPlansRef.current) getPlansRef.current()
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if (error.status === 404) {
                setMessage(`Failure, guest not found`)
            } else if (error.status === 400) {
                setMessage(`Failure, ${error.response.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false) }, 2000)
        })
    }

    const handleDeletePlan = async () => {
        setOpen(true)

        await axiosInstance.delete(`plans/delete/${selectedPlan?.plan_id}`).then(() => {
            setMessage(`Success, successfully deleted ${selectedPlan?.title}`)
            setTimeout(() => {
                setOpen(false);
                if (getPlansRef.current) getPlansRef.current()
                setIsDeleteModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if (error.status === 404) {
                setMessage("Plan not found")
            } else if (error.status === 400) {
                setMessage(error.response.error)
            } else {
                setMessage(error)
            }

            setTimeout(() => {
                setOpen(false)
            }, 2000)
        })
    }

    useEffect(() => {
        const getPlans = async () => {
            await axiosInstance.get(`plans/all`).then((response) => {
                setLoader(false)
                setPlans(response.data.data);
            }).catch((error) => {
                setLoader(false)
                if (error.response && error.response.data.message === "No plans found") {
                    setPlans([]);
                } else if (error.response && error.response.data.message !== "No plans found") {
                    // console.error(error.response.data)
                    setPlans([]);
                } else {
                    setPlans([]);
                    // console.log(error);
                }
            });
        }

        getPlansRef.current = getPlans;

        getPlans()
    }, [])

    if (loader) {
        return (
            <div className="h-screen w-full flex justify-center items-center">
                <CircularProgress />
            </div>
        )
    }

    return (
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Plans</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Plan</Button></div>
            </div>

            {plans.length > 0 ?
                <div className="grid grid-cols-1 lg:grid-cols-3 px-10 mt-4 gap-4">
                    {plans.map((plan, index) => (
                    <Card key={index} sx={{ borderRadius: 2, boxShadow: 6 }} className="w-full">
                        <CardContent>
                            <Typography variant="h5" align="center" gutterBottom className="flex items-center justify-center text-green-600">
                                {plan.title}
                            </Typography>
                            <p className="text-center"></p>
                            <Typography variant="h5" align="center" color="primary" gutterBottom>
                                Ugx {plan.price}
                            </Typography>
                            <List style={{ marginLeft: 50 }}>
                                {plan.features.split(',').map((feature, i) => (
                                    <ListItem key={i} disableGutters>
                                        <ListItemIcon>
                                            <CheckCircle color="success" />
                                        </ListItemIcon>
                                        <ListItemText primary={feature} />
                                    </ListItem>
                                ))}
                            </List>
                            <Box textAlign="center" mt={2}>
                                <Button variant="contained" color="primary" onClick={() => handleOpenEditModal(plan)} style={{ marginRight: 10 }}>
                                    Edit {plan.title}
                                </Button>
                                <Button variant="contained" color="error" onClick={() => handleOpenDeleteModal(plan)}>
                                    Delete {plan.title}
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                    ))}
                </div>
                :
                <div className="w-full text-red-800 font-bold text-center text-xl p-4 bg-red-400 border rounded border-red-600 mt-4">Plans not made yet</div>
            }

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete {selectedPlan?.title} plan?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeletePlan} color="error" variant="outlined">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit plan Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Edit Plan</h2>
                    <div>
                        <TextField variant="outlined" fullWidth type="text" value={selectedPlan?.title} onChange={(e) => setSelectedPlan((prev) => ({ ...prev, title: e.target.value }))} label="Entet title" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="number" value={selectedPlan?.price} onChange={(e) => setSelectedPlan((prev) => ({ ...prev, price: e.target.value }))} label="Price" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedPlan?.duration} onChange={(e) => setSelectedPlan((prev) => ({ ...prev, duration: e.target.value }))} label="Duration" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedPlan?.features} onChange={(e) => setSelectedPlan((prev) => ({ ...prev, features: e.target.value }))} label="Features" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" fullWidth variant="outlined">
                            Cancel
                        </Button>
                        <Button color="primary" fullWidth variant="outlined" onClick={handleEditPlan}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Plan Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Add Plan</h2>
                    <div>
                        <TextField variant="outlined" fullWidth type="text" value={plan.title} onChange={(e) => setPlan((prev) => ({ ...prev, title: e.target.value }))} label="Entet title" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="number" value={plan.price} onChange={(e) => setPlan((prev) => ({ ...prev, price: e.target.value }))} label="Price" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={plan.duration} onChange={(e) => setPlan((prev) => ({ ...prev, duration: e.target.value }))} label="Duration" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={plan.features} onChange={(e) => setPlan((prev) => ({ ...prev, features: e.target.value }))} label="Features" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddPlan}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Plans